import { useEffect } from "react";
import { useAuthStore } from "@/zustand/authStore";
import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import OpticksLogo from "@/components/ui/OpticksLogos/OpticksLogo";

const LicenseDeactivated = () => {
  const { setLogout } = useAuthStore((state) => state);

  useEffect(() => {
    setLogout();
  }, []);

  return (
    <>
      <OpticksLogo />
      <h2>License Deactivated</h2>

      <p>
        Your license has been deactivated and access to this account is no
        longer available.
      </p>
      <p>
        Please contact your Opticks representative or{" "}
        <OpticksLink
          href="mailto:support@optickssecurity.com"
          label="support@optickssecurity.com"
        />{" "}
        for more information or to reactivate your license.
      </p>
    </>
  );
};

export default LicenseDeactivated;
